<div class="flex no-internet-alert" [ngClass]="{ show: !online }">
  <div class="flex">
    <ie-icons
      icon="info-circle"
      class="mr-16"
      [width]="32"
      [height]="32"
    ></ie-icons>
  </div>
  <div class="flex flex-col">
    <div class="flex label-m fw-700">{{ 'YOU_ARE_OFFLINE' | translate }}</div>
    <div class="flex label-m">{{ 'NO_INTERNET_CONNECTION' | translate }}</div>
  </div>
</div>
